// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right[data-v-2d1de62a] {\n  padding: 50px 0 0 100px;\n}\n.right .item[data-v-2d1de62a] {\n    margin: 30px 0;\n}\n", ""]);
// Exports
module.exports = exports;
